// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"959":"a4526119","2104":"17006f36","2548":"6828c926","2592":"d080cdcf","2637":"d080cdcf","3647":"1fe17bd8","5961":"d080cdcf","6233":"4c6073c5","6399":"1c9b63a4","6664":"8c3fa2d8","8801":"a58b7d6b"}[chunkId] + ".chunk.css";
};